import React, { memo } from "react"
import styles from "./Event.module.css"
import moment from 'moment'
import 'moment/locale/ru'


const Event = ({ data }) => {
    const formatDateDisplay = () => {
        if (!data.start_time) {
            return 'Дата не указана'
        }

        const hasEndTime = data.end_time && data.end_time !== data.start_time
        if (hasEndTime) {
            return `c ${moment(data.start_time).format('DD MMM YYYY')} по ${moment(data.end_time).format('DD MMM YYYY')}`
        }
        return moment(data.start_time).format('DD MMMM YYYY')
    }
    
    const date = formatDateDisplay()
    
    return (
        <div className={styles.eventItem}>
            <div className={styles.textContent}>
                <h2 className={styles.title}>
                    {data.name}
                </h2>
                <div>
                    {/* <span style={{ marginRight: '11px', color: '#73982C', backgroundColor: '#E2EEDD' }} className="status">продуктивность</span> */}
                    <span className="time">{date}</span>
                </div>
            </div>
            <img src={data.media.thumb ? data.media.thumb : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASIAAACuCAMAAAClZfCTAAAAA1BMVEUAAACnej3aAAAASElEQVR4nO3BMQEAAADCoPVPbQhfoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABeA8XKAAFZcBBuAAAAAElFTkSuQmCC'} alt='Картинка' />
        </div>
    )
}
export default memo(Event)


